"use strict";
exports.__esModule = true;
exports.DividendOptions = void 0;
var DividendOptions;
(function (DividendOptions) {
    DividendOptions["ccc"] = "DIV-C; LTCG-C; STCG-C";
    DividendOptions["rrr"] = "DIV-R; LTCG-R; STCG-R";
    DividendOptions["ccr"] = "DIV-C; LTCG-C; STCG-R";
    DividendOptions["crr"] = "DIV-C; LTCG-R; STCG-R";
    DividendOptions["crc"] = "DIV-C; LTCG-R; STCG-C";
    DividendOptions["rcc"] = "DIV-R; LTCG-C; STCG-C";
    DividendOptions["rrc"] = "DIV-R; LTCG-R; STCG-C";
    DividendOptions["rcr"] = "DIV-R; LTCG-C; STCG-R";
})(DividendOptions = exports.DividendOptions || (exports.DividendOptions = {}));
